<div class="wrapper-stepper">
    <div class="upper-bar">
        <h2>
            <button
                class="btn btn-link"
                style="color: white; font-size: inherit !important"
                (click)="backToSelectWizard()"
            >
                <i class="far fa-chevron-left" style="cursor: pointer"></i>
            </button>
            {{ 'app.wizard.upper_bar.informacion' | translate }}
        </h2>
    </div>
    <div class="py-3 px-4 w-100 step-container">
        <div class="info-container">
            <div class="title-template">
                <h2
                    class="color-secundario mb-3"
                    [innerHTML]="'app.wizard.stepper_ia.vamos-crear-sitio' | translate"
                ></h2>
            </div>
            <div class="info-form mb-2">
                <div class="col-12 col-lg-6 p-0 pl-md-2 pr-xl-4 site-name-container">
                    <form class="info-market-form w-100" (ngSubmit)="onFormSubmit()">
                        <mc-form-group-input
                            [form]="InfoMarketForm"
                            name="alias"
                            [label]="'app.wizard.stepper_ia.cual_es_el_nombre' | translate"
                            class.form-control-lg="size == 'lg'"
                            [placeholder]="'app.wizard.info_market.tienda_las_marias' | translate"
                            class.form-control-sm="true"
                            ngClass="{ 'is-invalid': submitted && controlInvalid }"
                            [submitted]="submitted"
                        >
                        </mc-form-group-input>
                    </form>
                </div>
                <div class="col-12 col-lg-6 p-0 pr-md-2 pl-xl-4">
                    <div class="file-uploader">
                        <label class="upload-logo-text">{{ 'app.wizard.stepper_ia.agrega_tu_logo' | translate }}</label>
                        <app-file-upload-wizard
                            (deleteLogoEmitter)="deleteLogo()"
                            [logoLoaded]="urlLogo"
                            [stepName]="stepName"
                            [deleteFileLogo]="deleteFileLogo"
                            [errorElementName]="'logo'"
                            (sendLogoUrlToParent)="getLogoUrl($event)"
                            [module]="module"
                            [relation_id]="0"
                        ></app-file-upload-wizard>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="subtitle-content color-texto2 sub-title">
                    {{ 'app.wizard.stepper_ia.cuentanos-negocio' | translate }}
                </p>
                <voice-recorder
                    [initialText]="InfoMarketForm.get('prompt')?.value"
                    [maxChars]="1000"
                    (transcript)="InfoMarketForm.get('prompt')?.setValue($event)"
                ></voice-recorder>
                <p class="undertitle-content color-texto2 sub-title ml-2 mt-1">
                    {{ 'app.wizard.stepper_ia.ia-comete-errores' | translate }}
                </p>
            </div>
            <div>
                <p class="subtitle-content color-texto2 sub-title">
                    {{ 'app.wizard.stepper_ia.elige-tono' | translate }}
                </p>
                <div class="div-verticales">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-3 text-left" *ngFor="let vertical of verticalList">
                        <p
                            [ngClass]="
                                verticalSelected == vertical.name
                                    ? 'select-chip bg-color-destacados color-secundario'
                                    : 'vertical-chip color-texto2'
                            "
                            (click)="setVertical(vertical.name)"
                        >
                            <span> {{ vertical.name }} </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn-div px-4">
        <button class="btn btn-link color-link back-btn" (click)="backToSelectWizard()">
            <i class="fas fa-chevron-left mr-1"></i>{{ 'app.global.modals.volver' | translate }}
        </button>
        <div class="h-100">
            <button [disabled]="!InfoMarketForm.valid" (click)="onFormSubmit()" class="btn btn-continue">
                <i class="fas fa-sparkles"></i>
                {{ 'app.global.modals.continuar' | translate }}
            </button>
        </div>
    </div>
</div>
